<template>
	
<div id="payScuSure">
	<div class="paySuc-sec">
		<div class="suc-img">
			<img src="../../assets/images/paySucSure.png" alt="">
		</div>
		<div class="suc-operate-group">
			<span class="op-items" @click="checkPaySec(0)">已完成支付</span>
			<span class="op-items" @click="checkPaySec(1)">返回</span>
		</div>
	</div>
</div>
</template>
<script>
	import normalBar from '@/components/common/navbar/normalBar'
	import api from '@/api/api'
  import apiCommon from '@/api/common/api.common'
	import { Toast } from '@/js/mint-ui';
  import payHelper from '@/js/payHelper'
	export default {
		components: {
			normalBar
		},
		methods:{
			checkPaySec(type){
				let self = this;
				let payNo = this.$route.params.payNo;

        apiCommon.getPayResult({
          payNo: payNo
        },function(json){
          let res = json.body;
          if(res.data.paySuccess){
            self.$router.push({
              path: '/paySuccess/'+res.data.merchantId
            })
          }else {
            if(type == 0) {
              Toast('支付失败');
            }
            setTimeout(function(){
              self.$router.push({
                path: '/orderDetails/'+res.data.merchantId+'?url=/'
              })
            },2000);
          }
        })

			}
		}
	}
</script>
<style lang="scss">
	@import '../../assets/css/mixin';

</style>


// WEBPACK FOOTER //
// paySucSure.vue?09734d86